import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=357104ad&scoped=true&lang=pug&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=357104ad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357104ad",
  null
  
)

component.options.__file = "NotFound.vue"
export default component.exports